const status = {
  internal_review: 'internal_review',
  approved_internally: 'approved_internally',
  payment_initialized: 'payment_initialized',
  paid: 'paid',
  void: 'void',
};

export function getPayoutStatusColor(payoutStatus) {
  let color;
  switch (payoutStatus) {
    case status.approved_internally:
      color = 'green';
      break;
    case status.payment_initialized:
      color = 'blue';
      break;
    case status.paid:
      color = 'brand';
      break;
    case status.void:
      color = 'red';
      break;
    default:
      color = 'gray';
  }
  return color;
}
